import { jsonStringify } from '@ringcentral/rwc-utils/src/lang/json';

export const downloadFile = (href, name = '') => {
    const anchor = document.createElement('a');
    anchor.href = href;
    if (name) {
        anchor.download = name;
    }

    document.body.appendChild(anchor);

    if (typeof MouseEvent === 'function') {
        anchor.dispatchEvent(
            new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window,
            })
        );
    } else {
        const event = document.createEvent('Event');
        event.initEvent('click', true, true);
        anchor.dispatchEvent(event);
    }

    document.body.removeChild(anchor);
};

// @link https://en.wikipedia.org/wiki/Byte_order_mark
const UTF8_BOM = new Uint8Array([0xef, 0xbb, 0xbf]);

interface GetPlainTextBlobOptions extends BlobPropertyBag {
    // add BOM for services who cannot handle charset correctly such as CPR. `true` for utf8 BOM.
    bom?: Uint8Array | boolean | string;
}

export function getPlainTextBlob(text: string, { bom, ...options }: GetPlainTextBlobOptions = {}) {
    const _bom = bom && (bom === true ? UTF8_BOM : bom);
    return new Blob(_bom ? [_bom, text] : [text], { type: 'text/plain;charset=utf-8', ...options });
}

export function getJsonBlob(json: unknown, options?: GetPlainTextBlobOptions) {
    return getPlainTextBlob(jsonStringify(json), {
        type: 'application/json',
        ...options,
    });
}
